<template>
  <v-card>
    <canvas id="user-growth"></canvas>
  </v-card>
</template>

<script>
import { countObjectsByKey } from "../../util/aggregate";
import Chart from "chart.js";
import { timestampToLocaleISO } from "../../util/dateHelpers";

export default {
  name: "cumulative-user-growth.vue",

  data: function () {
    return {
      userRegistrationTimes: [],
      cumulativeRegistrations: [],
    };
  },

  async mounted() {
    this.userRegistrationTimes = await this.getUserRegistrationTimes();
    this.userRegistrationTimes = await this.addLocaleTimestamps(this.userRegistrationTimes);
    let groupedByDate = countObjectsByKey(this.userRegistrationTimes, "date_created");
    console.log("grouped by date");
    console.log(groupedByDate);

    // handle users with no registration date
    const priorRegistrations = groupedByDate["1969-12-31"] || 0;
    delete groupedByDate["1969-12-31"]; // Remove dates with registration unknown
    groupedByDate[Object.keys(groupedByDate)[0]] += priorRegistrations;

    groupedByDate = this.fillMissingDates(groupedByDate);

    this.cumulativeRegistrations = this.cumulativeSum(groupedByDate);
    console.log(this.cumulativeRegistrations);
    this.populateChart();
  },

  methods: {
    timestampToLocaleISO,

    async getUserRegistrationTimes() {
      const response = await this.$axios.get("/user-registration-times");
      return response.data;
    },

    async addLocaleTimestamps(timestamps) {
      return await timestamps.map((item) => ({
        time_created: item.time_created,
        date_created: this.timestampToLocaleISO(item.time_created),
      }));
    },

    cumulativeSum(obj) {
      let cumulativeSums = {};

      const keys = Object.keys(obj);
      let sum = 0;
      for (let key of keys) {
        sum += obj[key];
        cumulativeSums[key] = sum;
      }

      return cumulativeSums;
    },

    fillMissingDates(dateValues) {
      const MILLISECONDS_PER_DAY = 86400000;
      let filled = {};
      const dates = Object.keys(dateValues);
      const firstDate = new Date(dates[0]);
      const lastDate = new Date(dates.at(-1));

      let date = firstDate;
      while (date.getTime() <= lastDate.getTime()) {
        let dateIso = date.toISOString().split("T")[0];
        if (dateValues[dateIso] === undefined) {
          filled[dateIso] = 0;
        } else {
          filled[dateIso] = dateValues[dateIso];
        }
        date = new Date(date.getTime() + MILLISECONDS_PER_DAY);
      }
      return filled;
    },

    populateChart() {
      // Convert to x-y data
      let data = [];
      const keys = Object.keys(this.cumulativeRegistrations);
      for (let key of keys) {
        const record = {
          x: key,
          y: this.cumulativeRegistrations[key],
        };
        data.push(record);
      }
      console.log(data);

      new Chart(document.getElementById("user-growth"), {
        type: "line",
        data: {
          labels: Object.keys(this.cumulativeRegistrations),
          datasets: [
            {
              label: "Users over time",
              borderColor: "rgb(0, 0, 255)",
              fill: "rgb(150, 150, 255)",
              data,
            },
          ],
        },
        options: {
          scales: {
            x: {
              min: "2022-10-00",
            },
          },
          elements: {
            point: {
              radius: 0,
            },
          },
        },
      });
    },
  },
};
</script>

<style scoped></style>
